import React from 'react';

import { useAppSelector } from '@pkg/hooks';

import { Stats } from './Stats';
import { TabNav } from './TabNav';

import { Wrapper } from './styles';

export const ProfileNav = () => {
    const marketplaceEnabled = useAppSelector((state) => state.featureFlags.features.marketplaceEnabled);

    return (
        <Wrapper $marketplaceEnabled={marketplaceEnabled}>
            <TabNav />
            <Stats />
        </Wrapper>
    );
};
